/**
 * The three statements a person affirms with an accredited-investor answer. The server freezes
 * the same three keys in the snapshot of the certification (`accreditation_service`), so every
 * screen that asks the question shows all three: the profile modal and the signing screen.
 */
export const ACCREDITATION_AFFIRMATIONS: readonly string[] = [
  'I certify that the information above is true and complete, and I understand ' +
    'QMI will rely on it to determine my eligibility under Rule 506(b) of Regulation D.',
  'I understand this is a private investment: it is not registered with the SEC ' +
    'or any regulator, it is illiquid, returns are not guaranteed, and I can afford ' +
    'a complete loss of this investment.',
  'I agree to notify QMI promptly if my accredited status changes.',
];
